<div class="fadein image-container">
  <img class="image-background" src="./assets/images/Mach-E2.webp" width="1438" height="665"
       alt="Background image of a Ford MachE">
  <img class="image-background" src="./assets/images/Mustangs-2.webp" width="1919" height="870"
       alt="Background image of Ford Mustangs">
  <img class="image-background" src="./assets/images/blue-mach-e2.webp" width="2047" height="897"
       alt="Background image of a Blue Ford MachE">
  <img class="image-background" src="./assets/images/BroncoSport.webp" width="1024" height="576"
       alt="Background image of a Ford Bronco Sport">
  <img class="image-background" src="./assets/images/ford-f-150.webp" width="1920" height="1280"
       alt="Background image of a Ford F-150 Truck">
</div>

<div class="image-foreground">
  <h1>OTA Software Release and Deployment</h1>
  <p>The Center of the Connected Experience for the Connected Vehicle</p>
  <!--  <ota-primary-button [label]="'User Guide'" (click)="userGuideClick()"></ota-primary-button>-->
  &nbsp;
  <!--  <ota-primary-button [label]="'FAQs'" (click)="faqClick()"></ota-primary-button>-->
</div>

